'use client';

import { useLayoutEffect } from 'react';
import { type AvailableLocale, textDirection } from './shared';

/**
 * Holds `<html lang dir>` on the locale the page renders in. The root layout
 * renders `lang="en"` for every page, so unmounting restores English, left to
 * right, for the pages that render no locale of their own. A layout effect, so a
 * locale switch never paints a frame in the old direction.
 */
export function DocumentLanguage({ locale }: { locale: AvailableLocale }) {
  useLayoutEffect(() => {
    const root = document.documentElement;
    root.lang = locale;
    root.dir = textDirection(locale);

    return () => {
      root.lang = 'en';
      root.removeAttribute('dir');
    };
  }, [locale]);

  return null;
}
